import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import CandidatureDetailsCommon from '../../commun/CandidatureDetailsCommon';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import NotFound404 from '../../commun/NotFound404';

const DetailsCandid = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem("authToken");
  const connectedRecruiterId = localStorage.getItem("userId");

  const [candidature, setCandidature] = useState(null);
  const [editedStatut, setEditedStatut] = useState(null);
  const [messageEntreprise, setMessageEntreprise] = useState('');
  const [dateEntretien, setDateEntretien] = useState('');
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!authToken) return navigate('/');
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        if (!res.ok) {
          setNotFound(true);
          return;
        }
        const data = await res.json();
        if (data.recruteurId !== connectedRecruiterId) {
          setNotFound(true); 
          return;
        }
        setCandidature(data);
        setEditedStatut(data.statut);
        setMessageEntreprise(data.messageEntreprise || '');
        setDateEntretien(data.dateEntretien || '');
      } catch (error) {
        console.error('Erreur lors du chargement de la candidature', error);
        setNotFound(true);
      }
    };
    fetchData();
    setNotFound(false);
  }, [id, authToken, API_BASE, navigate]);

  const handleCancel = () => navigate('/recruteur/candidature');
  if (notFound) return <NotFound404 />;

  return (
    <>
      <CandidatureDetailsCommon
        HeaderComponent={HeaderRec}
        headerProps={{
          recruteurName: localStorage.getItem("recruteurName"),
          authToken,
          userId: localStorage.getItem("userId"),
          userRole: "recruteur",
        }}
        candidature={candidature}
        editedStatut={editedStatut}
        setEditedStatut={setEditedStatut}
        messageEntreprise={messageEntreprise}
        setMessageEntreprise={setMessageEntreprise}
        dateEntretien={dateEntretien}
        setDateEntretien={setDateEntretien}
        onCancel={handleCancel}
        API_BASE={API_BASE}
        editable={false}
      />
       <Footer />
      <Chatbox userRole="recruteur" />
    </>
  );
};


export default DetailsCandid;
